import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import cx from 'classnames';
import { ControlInputContainer } from '../../../internal/components/ControlInputContainer';
import { CheckboxSucess12 } from '../../../icons';
import { useDeviceType } from '../../../responsive';
import { getStyles } from './styles';
var CheckboxComponent = /*#__PURE__*/React.forwardRef(function Checkbox(props, ref) {
  var disabled = props.disabled,
    invalid = props.invalid,
    label = props.label;
  var deviceType = useDeviceType();
  var styles = getStyles(deviceType);
  return /*#__PURE__*/React.createElement(ControlInputContainer, _extends({}, props, {
    type: "checkbox",
    className: cx(styles['checkbox'], disabled && styles['disabled'], invalid && styles['invalid'], !!label && styles['hasLabel']),
    ref: ref
  }), /*#__PURE__*/React.createElement("span", {
    className: styles['box']
  }, /*#__PURE__*/React.createElement(CheckboxSucess12, {
    color: "current_color"
  })), label && /*#__PURE__*/React.createElement("span", {
    className: styles['label']
  }, label));
});

/**
 * Компонент простого чекбокса с лейблом
 *
 * На телефоне имеет блочный дизайн и чекбокс справа
 *
 * @export
 * @param {ICheckboxProps} props
 * @returns
 */
export var Checkbox = /*#__PURE__*/React.memo(CheckboxComponent);